import { ITuple3 } from "./general";

export interface IWebEmbedCameraSettings {
	cameraPosition?: ITuple3,
	orbitTarget?: ITuple3,
	azimuthAngle?: number,
	polarAngle?: number,
}

export interface IWebEmbedPreviewSettings extends IWebEmbedCameraSettings {
	height: number;
	width: number;
}

export interface IWebEmbedSettings extends IWebEmbedCameraSettings {
	hintGraphic?: boolean;			 
	arButton?: boolean;					 
	enableZoom?: boolean;				
	enablePan?: boolean;				
	verticalOrbit?: boolean;		
	horizontalOrbit?: boolean;	
	dampingFactor?: number;			
	autoRotateSpeed?: number;		
}

export const initialiseWebEmbed = (): IWebEmbedSettings => {
	return {
		hintGraphic: false,
		arButton: true,
		enableZoom: false,
		enablePan: false,
		verticalOrbit: true,
		horizontalOrbit: true,
		dampingFactor: 0,
		autoRotateSpeed: 0,
	};
};